// -------------------- ADMIN ----------------------

export const newAdmin = /* GraphQL */ `
  mutation newAdmin(
    $username: String!
    $_name: String!
    $surname: String!
    $email: String!
  ) {
    createAdminUser(
      input: {
        username: $username
        name: $_name
        surname: $surname
        email: $email
      }
    ) {
      username
      _name
      surname
      email
    }
  }
`;

export const deleteAdminUser = /* GraphQL */ `
  mutation deleteAdminUser($username: String!) {
    deleteAdminUser(input: { username: $username }) {
      username
      _state
    }
  }
`;

// -------------------- CUSTOMER ----------------------

export const newCustomer = /* GraphQL */ `
  mutation newCustomer(
    $crm_id: String!
    $ragione_sociale: String!
    $c_description: String!
    $state: Boolean
    $account_type: String
    $timezone: String
    $webhook_url: String
  ) {
    createCustomer(
      input: {
        crm_id: $crm_id
        ragione_sociale: $ragione_sociale
        c_description: $c_description
        state: $state
        account_type: $account_type
        timezone: $timezone
        webhook_url: $webhook_url
      }
    ) {
      crm_id
      ragione_sociale
      c_description
      state
      account_type
      timezone
      webhook_url
    }
  }
`;

export const updateCustomer = /* GraphQL */ `
  mutation updateCustomer(
    $crm_id: String!
    $ragione_sociale: String!
    $c_description: String!
    $account_type: String
    $timezone: String
    $webhook_url: String
  ) {
    updateCustomer(
      input: {
        crm_id: $crm_id
        ragione_sociale: $ragione_sociale
        c_description: $c_description
        account_type: $account_type
        timezone: $timezone
        webhook_url: $webhook_url
      }
    ) {
      crm_id
      ragione_sociale
      c_description
      account_type
      timezone
      webhook_url
    }
  }
`;

export const deleteCustomer = /* GraphQL */ `
  mutation deleteCustomer($crm_id: String!) {
    deleteCustomer(input: { crm_id: $crm_id }) {
      crm_id
      ragione_sociale
      c_description
    }
  }
`;

export const stateCustomer = /* GraphQL */ `
  mutation stateCustomer($crm_id: String!, $state: Boolean!) {
    stateCustomer(input: { crm_id: $crm_id, state: $state }) {
      service_id
    }
  }
`;

// -------------------- TECH USER ------------------------

export const newTechUser = /* GraphQL */ `
  mutation newTechUser(
    $username: String!
    $email: String!
    $policy_id: Int!
    $customer_id: String!
  ) {
    createTechUser(
      input: {
        username: $username
        email: $email
        policy_id: $policy_id
        customer_id: $customer_id
      }
    ) {
      username
      email
      _state
      policy_id
    }
  }
`;

export const updateTechUser = /* GraphQL */ `
  mutation updateTechUser(
    $username: String!
    $email: String!
    $policy_id: Int!
  ) {
    updateTechUser(
      input: { username: $username, email: $email, policy_id: $policy_id }
    ) {
      username
      _state
    }
  }
`;

export const deleteTechUser = /* GraphQL */ `
  mutation deleteTechUser($username: String!) {
    deleteTechUser(input: { username: $username }) {
      username
      _state
    }
  }
`;

export const changeTechUserState = /* GraphQL */ `
  mutation changeTechUserState($username: String!, $state: Boolean!) {
    changeTechUserState(input: { username: $username, state: $state }) {
      username
      _state
    }
  }
`;

// -------------------- POLICY ------------------------
export const newPolicy = /* GraphQL */ `
  mutation newPolicy(
    $policy_name: String!
    $policy_description: String
    $quota_metric: String
    $quota_period: String
    $quota_limit: Int
    $max_calls_per_day: Int
  ) {
    createPolicy(
      input: {
        policy_name: $policy_name
        policy_description: $policy_description
        quota_metric: $quota_metric
        quota_period: $quota_period
        quota_limit: $quota_limit
        max_calls_per_day: $max_calls_per_day
      }
    ) {
      policy_id
      policy_name
      policy_description
      quota_metric
      quota_period
      quota_limit
      max_calls_per_day
    }
  }
`;

export const updatePolicy = /* GraphQL */ `
  mutation updatePolicy(
    $policy_id: Int!
    $policy_name: String!
    $policy_description: String
    $quota_metric: String
    $quota_period: String
    $quota_limit: Int
    $max_calls_per_day: Int
  ) {
    updatePolicy(
      input: {
        policy_id: $policy_id
        policy_name: $policy_name
        policy_description: $policy_description
        quota_metric: $quota_metric
        quota_period: $quota_period
        quota_limit: $quota_limit
        max_calls_per_day: $max_calls_per_day
      }
    ) {
      policy_id
      policy_name
      policy_description
      quota_metric
      quota_period
      quota_limit
      max_calls_per_day
    }
  }
`;

export const deletePolicy = /* GraphQL */ `
  mutation deletePolicy($policy_id: Int!) {
    deletePolicy(input: { policy_id: $policy_id }) {
      policy_id
      policy_name
      policy_description
    }
  }
`;

// -------------------- WORKSPACE ------------------------
export const newWorkspace = /* GraphQL */ `
  mutation newWorkspace(
    $workspace_name: String!
    $n_calls: Int!
    $start_time: String!
    $stop_time: String!
    $date_type: String!
    $policy_id: Int!
  ) {
    createWorkspace(
      input: {
        workspace_name: $workspace_name
        n_calls: $n_calls
        start_time: $start_time
        stop_time: $stop_time
        date_type: $date_type
        policy_id: $policy_id
      }
    ) {
      workspace_name
      n_calls
      start_time
      stop_time
      date_type
      policy_id
    }
  }
`;

export const updateWorkspace = /* GraphQL */ `
  mutation updateWorkspace(
    $workspace_name: String!
    $n_calls: Int!
    $start_time: String!
    $stop_time: String!
    $date_type: String!
    $policy_id: Int!
  ) {
    updateWorkspace(
      input: {
        workspace_name: $workspace_name
        n_calls: $n_calls
        start_time: $start_time
        stop_time: $stop_time
        date_type: $date_type
        policy_id: $policy_id
      }
    ) {
      workspace_name
      n_calls
      start_time
      stop_time
      date_type
      policy_id
    }
  }
`;

export const deleteWorkspace = /* GraphQL */ `
  mutation deleteWorkspace($workspace_name: String!, $policy_id: Int!) {
    deleteWorkspace(
      input: { workspace_name: $workspace_name, policy_id: $policy_id }
    ) {
      workspace_name
      policy_id
    }
  }
`;

// ----------------- LAYER ------------------

export const createLayer = /* GraphQL */ `
  mutation createLayer(
    $workspace_name: String!
    $policy_id: Int!
    $layer_name: String!
    $tier: String
  ) {
    createLayer(
      input: {
        workspace_name: $workspace_name
        policy_id: $policy_id
        layer_name: $layer_name
        tier: $tier
      }
    ) {
      workspace_name
      policy_id
      layer_name
      tier
    }
  }
`;

export const deleteLayer = /* GraphQL */ `
  mutation deleteLayer(
    $workspace_name: String!
    $policy_id: Int!
    $layer_name: String!
  ) {
    deleteLayer(
      input: {
        workspace_name: $workspace_name
        policy_id: $policy_id
        layer_name: $layer_name
      }
    ) {
      workspace_name
      policy_id
      layer_name
    }
  }
`;

// ----------------- WS-DOMAIN ------------------

export const addDomain = /* GraphQL */ `
  mutation addDomain(
    $workspace_name: String!
    $policy_id: Int!
    $domain_id: Int!
  ) {
    addDomainToWS(
      input: {
        workspace_name: $workspace_name
        policy_id: $policy_id
        domain_id: $domain_id
      }
    ) {
      domain_id
      domain_name
    }
  }
`;

export const deleteDomainWS = /* GraphQL */ `
  mutation deleteDomainWS(
    $workspace_name: String!
    $policy_id: Int!
    $domain_id: Int!
  ) {
    deleteDomainFromWS(
      input: {
        workspace_name: $workspace_name
        policy_id: $policy_id
        domain_id: $domain_id
      }
    ) {
      workspace_name
      domain_id
    }
  }
`;

// ---------------------- DOMAIN ---------------------
export const newDomain = /* GraphQL */ `
  mutation newDomain(
    $domain_id: Int!
    $domain_name: String!
    $domain_description: String
    $polygon: String!
  ) {
    createDomain(
      input: {
        domain_id: $domain_id
        domain_name: $domain_name
        domain_description: $domain_description
        polygon: $polygon
      }
    ) {
      domain_id
      domain_name
      domain_description
      polygon
    }
  }
`;

export const updateDomain = /* GraphQL */ `
  mutation updateDomain(
    $domain_id: Int!
    $domain_name: String!
    $domain_description: String
    $polygon: String!
  ) {
    updateDomain(
      input: {
        domain_id: $domain_id
        domain_name: $domain_name
        domain_description: $domain_description
        polygon: $polygon
      }
    ) {
      domain_id
      domain_name
      domain_description
      polygon
    }
  }
`;

export const deleteDomain = /* GraphQL */ `
  mutation deleteDomain($domain_id: Int!) {
    deleteDomain(input: { domain_id: $domain_id }) {
      domain_id
      domain_name
      domain_description
      polygon
    }
  }
`;

export const assignGroup = /* GraphQL */ `
  mutation assignGroup($input: AssignGroupInput!) {
    assignGroup(input: $input) {
      success
      username
      groupName
    }
  }
`;

export const assignUserToGroup = /* GraphQL */ `
  mutation assignUserToGroup($username: String!, $group_id: ID!) {
    assignUserToGroup(username: $username, group_id: $group_id) {
      success
      username
      group_id
    }
  }
`;

export const upsertGroup = /* GraphQL */ `
  mutation upsertGroup($group_id: ID!, $policy_id: Int!) {
    upsertGroup(group_id: $group_id, policy_id: $policy_id) {
      group_id
      group_name
      policy_id
    }
  }
`;

export const saveTimeseriesConfig = /* GraphQL */ `
  mutation saveTimeseriesConfig($config: String!) {
    saveTimeseriesConfig(input: { config: $config }) {
      config
      updated_at
    }
  }
`;
